import { QUERY_KEY } from "@/constant/queryKey";
import { adminAPIKeyApi } from "@/services/core/admin-api-key.api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Hook for creating admin api key
export function useCreateAdminApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ username }: { username: string }) =>
      adminAPIKeyApi.create(username),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.ADMIN_API_KEY],
      });
    },
  });
}

// Hook for deleting a admin api key
export function useDeleteAdminApiKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ username, id }: { username: string; id: number }) =>
      adminAPIKeyApi.delete({ username, id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY.ADMIN_API_KEY] });
    },
  });
}
